import React from "react";
import { SanitySlug } from "../../../config/build/models/sanitySlug";
import Text from "./TextInput";

export interface HoneypotFieldProps {
  name: string;
}

const HoneypotField = ({ name }: HoneypotFieldProps) => {
  const slug: SanitySlug = {
    current: name
  };

  return (
    <div className="hidden" style={{ display: "none" }}>
      <Text name={name} slug={slug} label="Leave empty!" />
    </div>
  );
};

export default HoneypotField;

